import { render, staticRenderFns } from "./MusicCard.vue?vue&type=template&id=72163666"
import script from "./MusicCard.vue?vue&type=script&lang=js"
export * from "./MusicCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports